import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ConsolidatedBillingOrderSelectCtrl implements IController {

  selectedId: any;
  options: any[];
  optionIds: string[];
  billingAccountIds: string[];
  isRequired: boolean;
  isDisabled: boolean;
  excludeIds: string[];
  ngPlaceholder: string;
  onChange: Function;


  private consolidatedBillingOrdersRef: any;
  public selectedConsolidatedBillingOrder: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $consolidatedBillingOrders, private $element) {
    this.consolidatedBillingOrdersRef = this.$consolidatedBillingOrders();
  }

  $onInit() {
    this._setSelected();
  };

  $onChanges(changes) {
    if ((changes.selectedId && !changes.selectedId.isFirstChange())
      || (changes.branchIds && !changes.branchIds.isFirstChange()) ){
      this._setSelected();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const billingAccountIdsRef = this.billingAccountIds;
    const excludeIdsRef = this.excludeIds;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'consolidated-billing-order';
        this.selectedIdsRef = selectedIdRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.excludeIdsRef = excludeIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.queryMapRef = {
          billingAccountIds: billingAccountIdsRef
        }
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({consolidatedBillingOrder: undefined, id: undefined});
          panel.destroy();
        } else {
          if (!!this.options) {
            const consolidatedBillingOrder = _.find(this.options, (o) => {
              return o.id === selectedId;
            })
            this.onChange({consolidatedBillingOrder: consolidatedBillingOrder, id: selectedId});
            panel.destroy();
          } else {
            this.consolidatedBillingOrdersRef.$asyncValues([selectedId])
              .then((consolidatedBillingOrders) => {
                this.onChange({consolidatedBillingOrder: consolidatedBillingOrders[0], id: selectedId});
                panel.destroy();
              });
          }
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({consolidatedBillingOrder: undefined});
  }

  private _setSelected() {
    if (!!this.selectedId) {
      if (!!this.options) {
        this.selectedConsolidatedBillingOrder = _.find(this.options, (o) => {
          return o.id === this.selectedId;
        });
        this._setSelectedText();
      } else {
        this.consolidatedBillingOrdersRef.$asyncValues([this.selectedId])
          .then((consolidatedBillingOrders) => {
            this.selectedConsolidatedBillingOrder = consolidatedBillingOrders[0];
            this._setSelectedText()
          });
      }
    } else {
      this.selectedConsolidatedBillingOrder = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedConsolidatedBillingOrder, 'id', '');
  }


}

angular
  .module('bringoz.admin.billing-accounts')
  .component('consolidatedBillingOrderSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<',
      options: '<?',
      optionIds: '<?',
      billingAccountIds: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./consolidated-billing-order-select.html').default,
    controller: ConsolidatedBillingOrderSelectCtrl
  });
